import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

// Element UI
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

// 全局样式
import './assets/css/global.css'

// 工具类
import request from './utils/request'

Vue.use(ElementUI)

Vue.config.productionTip = false

// 全局挂载axios
Vue.prototype.$http = request

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')